import * as React from "react";
import Ajax from "../../Ajax";
import TypeServices from "./TypeServices";

interface IFormProps {
    types: object,
    loadCart: any,
    session_id: any,
    onNoServicesChecked: (servicesSerial: number, checked: boolean) => void,
    cartItems: any
}
interface MyStates {
    ajaxLoaded: boolean,
}
export default class TypesList extends React.Component<IFormProps, MyStates>{

    constructor(props:IFormProps) {
        super(props);

        this.state = {
            ajaxLoaded: true,
        }

        this.getButtons();
    }

    public getButtons() {
        let buttons = [];
        Object.keys(this.props.types).map((i) => {
            if(this.props.types[i].services && this.props.types[i].services.length > 0){
                buttons.push(parseInt(i));
            }
        });

    }


    public render() {
        return (
            <>
                {
                    Object.keys(this.props.types).map( (i, num) => {
                        return (
                            <>
                            {this.props.types[i].services && this.props.types[i].services.length > 0 &&
                                <div key={'type_' + i} className="tab-pane fade" id={'servicesData'+i}>
                                    <TypeServices
                                        session_id={this.props.session_id}
                                        type={this.props.types[i]}
                                        loadCart={() => this.props.loadCart()}
                                        services_serial={num}
                                        onNoServicesChecked={(checked: boolean) => this.props.onNoServicesChecked(num, checked)}
                                        cartItems = {this.props.cartItems}
                                    />
                                </div>
                            }
                            </>

                        )
                    })
                }
            </>
        )
    }
}